import {
  GET_ADJUSTMENT,
} from '../actions/types';

const INITIAL_STATE = {
  adjustment: {},
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case GET_ADJUSTMENT:
      return {
        ...state,
        adjustment: action.data
      };
    default:
      return state;
  }
};